var _engine_config;
var _this;

class BehaviorAdaptative {

    constructor(_window, _document) {

        this.window = _window;
        this.document = _document;
        _this = this;
        
    }

    behaviorAdapt(engine_config) {

        var autoStyle = "";

        _engine_config = engine_config;
        this.removeMediaQueries();

        
        autoStyle += `
            * {
                text-rendering: optimizeLegibility;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                // -ms-flex-wrap: nowrap;
                // flex-wrap: nowrap; 
            }
        `;
       

        this.document.head.appendChild(Object.assign(this.document.createElement("style"), {textContent: autoStyle}))

        // $(this.document.body).find("*").css("-ms-flex-wrap", "nowrap");
        // $(this.document.body).find("*").css("flex-wrap", "nowrap");
        $(this.document.body).find("*").css("-webkit-font-smoothing", "antialiased");
        $(this.document.body).find("*").css("-moz-osx-font-smoothing", "grayscale");
        $(this.document.body).find("*").css("text-rendering", "optimizeLegibility");

        $('html').css("height", "-webkit-fill-available");
        $(this.document).find('html').css("height", "-webkit-fill-available");



        $( this.window ).resize(function() {
            _this.scaleTransformAll($(this.document.body));
        });

        this.scaleTransformAll($(this.document.body));

    }

   

    scaleTransformAll(div){
       
        var proportional = true; 
        var currentWidth = _engine_config.behaviors.width;
        var currentHeight = _engine_config.behaviors.height;
        var availableHeight = this.window.innerHeight;
        var availableWidth = this.window.innerWidth;
        var scaleX = availableWidth / currentWidth;
        var scaleY = availableHeight / currentHeight;
        var domRect;
        var positionX;
        var positionY;
        var viewport;
        var bgImage;
        var replacedBG;
        
        if (proportional) {
            scaleX = Math.min(scaleX, scaleY);
            scaleY = scaleX;
        }
        
        
        

        div.find(".simplePage").find(".container-template-wildcard").find(".row-wrap:first-child").css({"height":currentHeight + "px"});
        div.find(".simplePage").css({"height":currentHeight + "px"});
        div.find(".full-H").css({"height":currentHeight + "px"});
        div.find(".col-bg").css({"height":currentHeight + "px"});
        



        if($(div.find(".simplePage").find(".container-template-wildcard")[0]).css("background-image") != "none"){
            bgImage = $(div.find(".simplePage").find(".container-template-wildcard")[0]).css("background-image");
        }else if( $(div.find(".simplePage").find(".container-template-exercise-quiz")[0]).css("background-image") != "none"){
            bgImage =  $(div.find(".simplePage").find(".container-template-exercise-quiz")[0]).css("background-image");
        }else{
            bgImage = "none";
        }


        replacedBG = $(div.find(".simplePage").find(".container-template-wildcard")[0]).data("replacedBg");


        var position_type;

        if(div.find(".simplePage").length > 0){
            position_type = "fixed";
        }else if(div.find(".onePage").length > 0){
            position_type = "relative";
        }

        if(bgImage!="none"  && _engine_config.behaviors.fullBg == true || replacedBG == true){
            
            if(replacedBG!=true){

                $(div).css({"background-image":bgImage,
                            "background-size": "cover",
                            "background-repeat": "no-repeat",
                            // "background-position":"center center",
                            // "background-position":"0 0"
                           });


                $(div.find(".simplePage").find(".container-template-wildcard")[0]).data("replacedBg", true);
                $(div.find(".simplePage").find(".container-template-wildcard")[0]).css("background-image", "");
                

            }
          
            
            // position_type
            div.css({
                "position": `${position_type}`,
                "left": "0px",
                "top": "0px",
                "min-width": currentWidth + "px",
                "min-height": currentHeight + "px",
                "-webkit-transform": "translate(" + 0 + "px, "
                                                + 0 + "px) scale3d("
                                                + scaleX + ", " + scaleY + ", 1)",
                "-webkit-transform-origin": "0 0"
            }); 

        }else{

            div.css({
                "position": `${position_type}`,
                "-webkit-box-shadow": "0px 0px 14px 6px rgba(0,0,0,0.44)", 
                "box-shadow": "0px 0px 14px 6px rgba(0,0,0,0.44)",
                "left": "0px",
                "top": "0px",
                "min-width": currentWidth + "px",
                "min-height": currentHeight + "px",
                "-webkit-transform": "translate(" + 0 + "px, "
                                                + 0 + "px) scale3d("
                                                + scaleX + ", " + scaleY + ", 1)",
                "-webkit-transform-origin": "0 0"
            }); 

        }

        


        _this.changeFontSize(_engine_config);

        domRect = this.document.body.getBoundingClientRect();
        positionX = (this.document.documentElement.clientWidth/2) - (domRect.width/2);
        positionY = (this.document.documentElement.clientHeight/2) - (domRect.height/2);
        viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=' + domRect.width +', height=' + domRect.height + ', initial-scale=1.0, maximum-scale=1.0, user-scalable=0');



        if(div.find(".simplePage").length > 0){
            $(div).css({
                "background-position":`0px ${positionY}px`,
                "left":`${positionX}px`,
                "top":`${positionY}px`
            });

        }else if(div.find(".onePage").length > 0){
            $(div).css({
                "background-position":`0px ${positionY}px`,
                "left":`${positionX}px`,
                "top":`0px`
            });

           

            div.css({
                // "height":`${domRect.height/scaleY}px`
                
                
            });
        }

        

        if(_engine_config.behaviors.fullBg == true ){

            $(div).find('.component-template-header').css({
                "left":`${-Math.round(positionX/scaleX)}px`,
                "width":`${this.document.documentElement.clientWidth/scaleX}px`
            });

            $(div).find('.modal').css({
                "left":`${-Math.round(positionX/scaleX)}px`,
                "width":`${this.document.documentElement.clientWidth/scaleX}px`
            });

            $(div).find('.container-interaction-arrows').css({
                "left":`${-Math.round(positionX/scaleX)}px`,
                "width":`${this.document.documentElement.clientWidth/scaleX}px`,
                "position": "fixed",
                "bottom": 0,
                "display": "flex",
                "justify-content": "space-between"
            });

            
            $(div).find('.container-arrow').css({
                "position": "relative"
            });
        }

        $(div).find('.col-bg-int').css({
            "width":`${currentWidth/2}px`
        });

        

        
    
    }

    // getParentSize(element, ref){
        
    //     if(ref == "width"){
    //         if(element.parent().width() <= 0){
    //             _this.getParentSize(element, ref);
    //         }else{
    //             return element.parent().width();
    //         }
    //     }else if(ref == "height"){
    //         if(element.parent().height() <= 0){
    //             _this.getParentSize(element, ref);
    //         }else{
    //             return element.parent().height();
    //         }
    //     }
        
    // }

    changeFontSize(engine_config){
        $(this.document).find('p,h1,h2,h3,h4,h5,i,b,stronger,small').each(function(){
            var font_size_older; 
            var font_size_new;
            var font_size_px;

            if($(this).data('fontRef') != undefined || $(this).data('fontRef') != null){
                font_size_older = $(this).data('fontRef');
            }else{
                font_size_older = $(this).css('font-size');
            }

            
            $(this).data('fontRef', font_size_older);
            font_size_px = Math.round(font_size_older.split("px")[0]);

            var fonteMedia = (font_size_px + engine_config.behaviors.fontSize) /2;
            font_size_new = fonteMedia * 0.063;

            $(this).css('font-size', font_size_new + "rem");
               
            
        });
    }

    removeRule() {
        if (typeof _this.window.CSSMediaRule !== 'function') {
            return false;
        }
        var styleSheets = _this.document.styleSheets;
        var number = 0;
    
        if (!styleSheets) {
            return false;
        }
    
        for (var i = 0; i < styleSheets.length; i++) {
            var styleSheet = styleSheets[i];
            var rules = styleSheet.cssRules;
            if (!rules) {
                continue;
            }
            for (var j = 0; j < rules.length; j++) {
                var cssText = rules[j].cssText;
                var ruleStyle = rules[j].style;
                
                if (cssText.indexOf('@media') === 0) {
                    number++;
                    styleSheet.deleteRule(j);
                }
            }
        }
        if (number) {
            return number;
        }
        return 0;
    }
    
    removeMediaQueries() {
        var num = _this.removeRule();
        var total = num;
        while (num) {
            num = _this.removeRule();
            total += num;
        }
        if (total) {
            // console.info(total + ' media quer' + (total == 1 ? 'y' : 'ies' + ' removed'));
        } else {
            // console.info('No media queries removed');
        }
    }

    

}